module.exports = __webpack_public_path__ + "img/volume_off.fceb24de.svg";